module.exports = "/_next/static/images/02329c4223d3a513ca5d02a287d480b7-cajita-lg.png.webp";